import type { HTMLAttributes, PropsWithChildren } from "react";

import { useViewportInfoContext } from "@/src/contexts";
import * as stylex from "@stylexjs/stylex";

import { type PropsWithStyleX, containerSize } from "../../styles/tokens.stylex";

const styles = stylex.create({
    container: {
        margin: containerSize.containerMargin,
        padding: containerSize.containerPadding,
        maxWidth: containerSize.containerMaxWidth,
        width: containerSize.containerWidth,
    },
    mobile: {
        width: containerSize.containerWidthMobile,
    },
    fullWidth: {
        maxWidth: "unset",
        width: "100%",
    },
});

type IContainer = PropsWithChildren &
    PropsWithStyleX &
    HTMLAttributes<HTMLElement> & {
        Element?: "div" | "nav" | "section" | "article" | "aside" | "header" | "main" | "footer";
        fullWidth?: boolean;
    };

export default function Container({
    children,
    styleX: style,
    Element = "div",
    fullWidth = false,
    ...props
}: IContainer) {
    const { isMobile } = useViewportInfoContext();

    return (
        children && (
            <Element
                {...props}
                {...stylex.props(
                    styles.container,
                    isMobile && styles.mobile,
                    fullWidth && styles.fullWidth,
                    style,
                )}
            >
                {children}
            </Element>
        )
    );
}
